"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var ToggleGroup = _interopRequireWildcard(require("@radix-ui/react-toggle-group"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _segmentedcontrolTokens = require("./segmentedcontrol.tokens.js");
var _focus = require("@react-aria/focus");
var _jsxRuntime = require("react/jsx-runtime");
var SegmentedControlItem = (0, _styledComponents.default)(ToggleGroup.Item).withConfig({
  displayName: "SegmentedControl__SegmentedControlItem",
  componentId: "sc-zk6vkv-0"
})(["display:flex;flex:1 1 0;justify-content:center;align-items:center;gap:", ";box-sizing:border-box;", ";height:", ";padding:", " ", " ", " ", ";margin:2px 0;outline:none;background-color:", ";border-color:", ";border-width:", ";border-style:solid;color:", ";cursor:pointer;svg{path{fill:", ";}}&:hover:not(:disabled){background-color:", ";border-color:", ";color:", ";svg{path{fill:", ";}}}&[data-state='on']:not(:disabled){background-color:", ";border-color:", ";color:", ";svg{path{fill:", ";}}}&:disabled{cursor:default;background-color:", ";border-color:", ";color:", ";svg{path{fill:", ";}}}&.has-error{border-color:", ";}&.focus-ring{z-index:1;", ";}&:not(:first-child){margin-left:-1px;}&:first-child{border-top-left-radius:", ";border-bottom-left-radius:", ";}&:last-child{border-top-right-radius:", ";border-bottom-right-radius:", ";}"], _globalTokens.globalSpacing['200'], _segmentedcontrolTokens.tokens.font.standard, _segmentedcontrolTokens.tokens.size.height, _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['300'], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['300'], _segmentedcontrolTokens.tokens.color.background.default, _segmentedcontrolTokens.tokens.color.border.default, _globalTokens.globalBorder.width.thin, _segmentedcontrolTokens.tokens.color.font.default, _segmentedcontrolTokens.tokens.color.icon.default, _segmentedcontrolTokens.tokens.color.background.hover, _segmentedcontrolTokens.tokens.color.border.hover, _segmentedcontrolTokens.tokens.color.font.hover, _segmentedcontrolTokens.tokens.color.icon.hover, _segmentedcontrolTokens.tokens.color.background.checked, _segmentedcontrolTokens.tokens.color.border.checked, _segmentedcontrolTokens.tokens.color.font.checked, _segmentedcontrolTokens.tokens.color.icon.checked, _segmentedcontrolTokens.tokens.color.background.disabled, _segmentedcontrolTokens.tokens.color.border.disabled, _segmentedcontrolTokens.tokens.color.font.disabled, _segmentedcontrolTokens.tokens.color.icon.disabled, _segmentedcontrolTokens.tokens.color.border.error, _segmentedcontrolTokens.tokens.focusRing, _globalTokens.globalBorder.radius['5'], _globalTokens.globalBorder.radius['5'], _globalTokens.globalBorder.radius['5'], _globalTokens.globalBorder.radius['5']);
var SegmentedControlRoot = (0, _styledComponents.default)(ToggleGroup.Root).withConfig({
  displayName: "SegmentedControl__SegmentedControlRoot",
  componentId: "sc-zk6vkv-1"
})(["display:flex;&.has-error{", "{border-color:red;}}"], SegmentedControlItem);
var Item = function Item(_ref) {
  var value = _ref.value,
    label = _ref.label,
    disabled = _ref.disabled,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: "focus-ring",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SegmentedControlItem, {
      disabled: disabled,
      value: value,
      "aria-label": label || value,
      children: children
    })
  });
};
exports.Item = Item;
var SegmentedControl = function SegmentedControl(_ref2) {
  var children = _ref2.children,
    value = _ref2.value,
    label = _ref2.label,
    _ref2$onValueChange = _ref2.onValueChange,
    onValueChange = _ref2$onValueChange === void 0 ? function () {
      return void 0;
    } : _ref2$onValueChange,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$error = _ref2.error,
    error = _ref2$error === void 0 ? false : _ref2$error;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SegmentedControlRoot, {
    type: "single",
    "aria-label": label,
    value: value,
    onValueChange: onValueChange,
    disabled: disabled,
    className: error ? 'has-error' : undefined,
    children: children
  });
};
SegmentedControl.Item = Item;
var _default = exports.default = SegmentedControl;